export default function Courses() {
  const courses = [
    {
      title: '数学強化コース',
      subtitle: '(中学生)',
      schedule: [
        '1年生:毎週水曜 19時~20時',
        '2年生:毎週金曜 19時~20時',
        '3年生:毎週火曜、木曜 19時~20時'
      ],
      description: '基本から応用まで、高校入試に対応できる力を身に付けます。単元ごとにポイントをしぼった教材を用意。理解をより深め、入試に対応できる力を身に付けます。',
      price: '8,000円',
      priceUnit: '月額1コマあたり',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/da10e06bfba82bacdb88594d087b0bb9.jpeg'
    },
    {
      title: 'スタディコース',
      subtitle: '(どの教科でも)',
      schedule: [
        '火曜~金曜までの18時~19時、20時~21時から好きな時間帯を選択',
        '※学年問わず'
      ],
      description: '少人数個別指導により、分からないところを徹底理解します。普段の学習の悩みや入試までの取り組み方についてもサポート!第1志望校への合格を目指すコースです。',
      price: '8,000円',
      priceUnit: '月額1コマあたり',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/6225996758aeec267422d5742c920c8b.jpeg'
    },
    {
      title: 'サポートコース',
      subtitle: '',
      schedule: [
        '月曜 18時~19時30分'
      ],
      description: '自分で教材を持参、宿題や授業で分からないところを先生に質問し、自学自習スタイルで取り組むコースです。',
      price: '500円',
      priceUnit: '1回',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/6e13a3d80ada2eef8294b839b6e2dafb.jpeg'
    },
    {
      title: '完全個別指導コース',
      subtitle: '',
      schedule: [
        '事前に時間帯を予約'
      ],
      description: 'マンツーマン指導で、徹底的に理解を深めます!予約制になりますので事前にご連絡ください!',
      price: '6,000円',
      priceUnit: '1回',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/1cb7cfca047af27e1f9c6a22744e553c.jpeg'
    }
  ];

  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-white">
      <div className="max-w-lg md:max-w-4xl lg:max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 text-[#1A2B4A] mb-3">
            <i className="ri-book-open-line text-xl"></i>
            <span className="text-sm font-medium tracking-wider uppercase">COURSES</span>
          </div>
          <h2 className="text-[36px] md:text-[44px] font-black text-[#1A2B4A] leading-tight">
            コース紹介
          </h2>
        </div>

        <div className="space-y-8 md:space-y-12">
          {courses.map((course, index) => (
            <div
              key={index}
              className={`bg-white rounded-3xl shadow-lg overflow-hidden md:flex ${
                index % 2 === 1 ? 'md:flex-row-reverse' : ''
              }`}
            >
              <div className="relative h-64 md:h-auto md:w-2/5">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 md:p-8 md:w-3/5">
                <h3 className="text-[24px] md:text-[28px] font-bold text-[#1A2B4A] mb-2">
                  {index + 1}. {course.title}
                  {course.subtitle && (
                    <span className="text-[20px] md:text-[24px] ml-2">{course.subtitle}</span>
                  )}
                </h3>

                <div className="mb-4">
                  {course.schedule.map((time, idx) => (
                    <div
                      key={idx}
                      className="inline-block bg-[#FAF8F5] text-[#1A2B4A] px-4 py-2 rounded-lg text-sm mr-2 mb-2"
                    >
                      {time}
                    </div>
                  ))}
                </div>

                <p className="text-[#6B7280] text-sm md:text-base leading-relaxed mb-6">
                  {course.description}
                </p>

                <div className="flex items-baseline gap-2">
                  <span className="text-[#6B7280] text-sm">{course.priceUnit}</span>
                  <span className="text-[#FF6B35] text-3xl md:text-4xl font-bold">
                    {course.price}
                  </span>
                  <span className="text-[#6B7280] text-sm">(税込)</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
